import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { DefaultTopLevelGroup, Status } from "../../common/constants";
import { dashboardDetailsUrl } from "../../config";
import api from "../../api";
import { IDashboardDetails } from "../../common/types/devicesTypes"

const GET_DASHBOARD_DETAILS: string = "getDashboardDetails";

const initialState: IDashboardDetails = {
    message: null,
    status: Status.IDLE,
    error: null,
    data: null
};
export const getDashboardDetails = createAsyncThunk(GET_DASHBOARD_DETAILS, async () => {
    try {
        const dashboardDetailsResponse = await api.get<IDashboardDetails>(`${dashboardDetailsUrl}?orgId=${DefaultTopLevelGroup.ID}`);
        return dashboardDetailsResponse.data;
    } catch (error) {
        throw error;
    }
});

const dashboardSlice = createSlice({
    name: GET_DASHBOARD_DETAILS,
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDashboardDetails.pending, (state) => {
                state.status = Status.PENDING;
            })
            .addCase(getDashboardDetails.fulfilled, (state, action) => {
                state.status = Status.SUCCESS;
                state.data = action.payload.data;
                state.message = action.payload.message;
            })
            .addCase(getDashboardDetails.rejected, (state, action) => {
                state.status = Status.FAILED;
                state.error = action.error.message;
            })
    },
});

type Selector = {
    dashboardApi: ReturnType<
        typeof dashboardSlice.reducer
    >;
};

export const selector = (store: Selector) => store['dashboardApi'];

export default dashboardSlice.reducer;